interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
}: SectionHeadingProps) {
  const alignment =
    align === "center"
      ? "items-center text-center"
      : "items-start text-left";

  return (
    <div className={`mb-8 flex flex-col md:mb-10 ${alignment}`}>
      {eyebrow ? (
        <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium tracking-wide text-primary-800">
          <span className="h-1.5 w-1.5 rounded-full bg-primary-500"></span>
          {eyebrow}
        </span>
      ) : null}
      <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
        {title}
      </h2>
      {desc ? (
        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
          {desc}
        </p>
      ) : null}
    </div>
  );
}